import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";

export const DivContainer = styled.section`
  position: fixed;
  top: ${GLOBAL_NAVI_HEIGHT.PC}px;
  left: 0;
  width: 100%;
  z-index: 100;
  padding: var(--sat) var(--sar) var(--sab) var(--sal);
  ${mq.sp} {
    top: ${GLOBAL_NAVI_HEIGHT.SP}px;
  }
`;
